module.exports = __webpack_public_path__ + "static/img/close-black.13a2214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-black.png
// module id = 250
// module chunks = 0